module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Social-Static-Ad-w960.dd2163bc.png";